import { render } from "./accordian.vue?vue&type=template&id=427e3902&scoped=true"
import script from "./accordian.vue?vue&type=script&lang=js"
export * from "./accordian.vue?vue&type=script&lang=js"

import "./accordian.vue?vue&type=style&index=0&id=427e3902&scoped=true&lang=css"

import exportComponent from "/Users/farhanlatif/Code/admin-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427e3902"]])

export default __exports__